import { element } from '../../../core/elements';
import { TooltipHeader } from '../../../primitives/tooltip/tooltips/TooltipHeader';
import { TooltipRow } from '../../../primitives/tooltip/tooltips/TooltipRow';
import TooltipWithBounds from '../../../primitives/tooltip/tooltips/TooltipWithBounds';
import Formatters from '../../../primitives/utils/formatters';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
function MultiSeriesTooltip(_ref) {
  var _tooltipData$nearestD, _window, _window2, _tooltipData$nearestS;
  let {
    tooltipData,
    tooltipLeft,
    tooltipTop,
    xAccessor,
    yAccessor,
    colorAccessor,
    colorScale,
    valueFormatter = Formatters.formatNumberAbbreviated
  } = _ref;
  const datum = tooltipData === null || tooltipData === void 0 ? void 0 : (_tooltipData$nearestD = tooltipData.nearestDatum) === null || _tooltipData$nearestD === void 0 ? void 0 : _tooltipData$nearestD.datum;

  // TODO: SSR check
  const scrollX = ((_window = window) === null || _window === void 0 ? void 0 : _window.scrollX) || 0;
  const scrollY = ((_window2 = window) === null || _window2 === void 0 ? void 0 : _window2.scrollY) || 0;
  const portalLeft = tooltipLeft + scrollX;
  const portalTop = tooltipTop + scrollY;
  return /*#__PURE__*/_jsx(_Fragment, {
    children: datum && /*#__PURE__*/_jsxs(TooltipWithBounds, {
      // needed for bounds to update correctly
      left: portalLeft,
      top: portalTop,
      tooltipPortalElement: document.body,
      children: [/*#__PURE__*/_jsx(TooltipHeader, {
        children: xAccessor(datum) instanceof Date ? Formatters.multiTimeFormat(xAccessor(datum)) : String(xAccessor(datum))
      }), tooltipData === null || tooltipData === void 0 ? void 0 : (_tooltipData$nearestS = tooltipData.nearestSeriesData) === null || _tooltipData$nearestS === void 0 ? void 0 : _tooltipData$nearestS.map((d, i) => /*#__PURE__*/_jsx(TooltipRow, {
        color: colorScale(colorAccessor(d)),
        label: colorAccessor(d),
        value: String(valueFormatter(yAccessor(d)))
      }, String(xAccessor(d)) + i))]
    }, Math.random())
  });
}
const _MultiSeriesTooltip = element(MultiSeriesTooltip);
export { _MultiSeriesTooltip as MultiSeriesTooltip };